import { render, staticRenderFns } from "./CoMyTicket.vue?vue&type=template&id=67c3d70f&"
import script from "./CoMyTicket.vue?vue&type=script&lang=ts&"
export * from "./CoMyTicket.vue?vue&type=script&lang=ts&"
import style0 from "./CoMyTicket.vue?vue&type=style&index=0&id=67c3d70f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports